<template>
  <v-dialog v-model="dialog" width="500">
    <v-card v-if="currentNotification">
      <v-card-title style="text-transform: uppercase" class="px-3">
        <v-icon color="accent" class="mr-2">mdi-bell</v-icon>
        {{ currentNotification.workspace_id ? currentNotification.workspace.name : currentNotification.output }}
        <v-spacer />
        <v-btn icon small @click="dialog = false"><v-icon small>mdi-close</v-icon></v-btn>
      </v-card-title>
      <v-card-text class="pb-0 px-3">
        <v-simple-table>
          <template v-slot:default>
            <tbody>
              <tr v-if="currentNotification.workspace && currentNotification.workspace.name">
                <td>Workspace</td>
                <td>{{ currentNotification.workspace.name }}</td>
              </tr>
              <tr>
                <td>Title</td>
                <td>{{ currentNotification.data.title }}</td>
              </tr>
              <tr>
                <td>Message</td>
                <td>{{ currentNotification.data.message }}</td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
        <v-divider />
      </v-card-text>
      <v-card-actions class="px-3 py-3" v-if="currentNotification.is_success">
        <v-spacer />
        <v-btn text @click="gotoDetail"><v-icon>mdi-open-in-new</v-icon></v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>

export default {
  name: 'detail-notification',
  data() {
    return {
      dialog: false,
      currentNotification: undefined
    }
  },
  computed: {
  },
  methods: {
    openDialog(data) {
      this.currentNotification = data
      this.dialog = true
    },
    gotoDetail() {
      this.$emit('gotoDetail', this.currentNotification)
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/notification/detail-notification.vue